import { render, staticRenderFns } from "./musicList.vue?vue&type=template&id=4d27a23c&scoped=true&"
import script from "./musicList.vue?vue&type=script&lang=js&"
export * from "./musicList.vue?vue&type=script&lang=js&"
import style0 from "./musicList.vue?vue&type=style&index=0&id=4d27a23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27a23c",
  null
  
)

export default component.exports